module.exports = __webpack_public_path__ + "img/icon-59.fc6f73eb.svg";